import React from 'react';

const ViewCollaboration = ({ event, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 text-white">
      <div className="bg-color pl-8 rounded-lg shadow-lg w-full max-w-2xl ml-24 mt-28 border-4 border-white border-solid">
        <h2 className="text-2xl mb-4">Project Details</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <strong>Poject Name:</strong> {event.projectName}
          </div>
          <div>
            <strong>Project sponser:</strong> {event.organizationName}
          </div>
          <div>
            <strong>Category:</strong> {event.category}
          </div>
          <div>
            <strong>Research Area:</strong> {event.researchArea}
          </div>
          <div>
            <strong>Start Date:</strong> {new Date(event.startDate).toLocaleDateString('en-GB')}
          </div>
          
          <div>
            <strong>End Date:</strong> {new Date(event.endDate).toLocaleDateString('en-GB')}
          </div>
          <div>
            <strong>Team Size:</strong> {event.teamSize}
          </div>
          <div>
            <strong>Team Members:</strong> {event.teamMembers}
          </div>
        </div>
        <div className="mt-6 flex justify-end mb-4 mr-4">
          <button
            onClick={onClose}
            className="bg-black text-white py-2 px-6 rounded-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCollaboration;
